import React from "react";
import { Eye, Target } from "lucide-react";
import { PageHero, PageBody, STATIC_CONTENT, renderInstituteHtml, FONT } from "./_shared";
import { useBul } from "./BulLayout";

export default function VisionMission() {
  const data = useBul();
  const inst = data.institute || {};
  const vision = (inst.vision || "").trim() || STATIC_CONTENT.vision;
  const mission = (inst.mission || "").trim() || STATIC_CONTENT.mission;
  return (
    <div data-testid="bul-vision-mission">
      <PageHero eyebrow="Direction" title="Vision & Mission" />
      <PageBody>
        <div className="grid md:grid-cols-2 gap-6">
          <article className="bg-[#0F0F10] text-white p-10" data-testid="bul-vision-block">
            <div className="w-12 h-12 border-2 border-[#FDBB30] flex items-center justify-center text-[#FDBB30] mb-6">
              <Eye size={22} strokeWidth={1.8} />
            </div>
            <div className="text-[10px] tracking-[0.4em] uppercase text-[#FDBB30] font-semibold">Our Vision</div>
            <h2 className="mt-3 text-3xl md:text-4xl leading-tight" style={{ fontFamily: FONT.serif, fontWeight: 600 }}>
              A globally recognised technical institution.
            </h2>
            <div
              className="mt-6 text-white/85 italic leading-[1.9] text-lg prose prose-invert prose-sm max-w-none"
              style={{ fontFamily: FONT.serif }}
              data-testid="bul-vision-text"
              dangerouslySetInnerHTML={{ __html: renderInstituteHtml(vision) }}
            />
          </article>
          <article className="bg-[#F8F5EE] p-10 border-l-4 border-[#FDBB30]" data-testid="bul-mission-block">
            <div className="w-12 h-12 border-2 border-[#0F0F10] flex items-center justify-center text-[#0F0F10] mb-6">
              <Target size={22} strokeWidth={1.8} />
            </div>
            <div className="text-[10px] tracking-[0.4em] uppercase text-[#726C61] font-semibold">Our Mission</div>
            <h2 className="mt-3 text-3xl md:text-4xl leading-tight text-[#0F0F10]" style={{ fontFamily: FONT.serif, fontWeight: 600 }}>
              Student-centric education, industry-aligned outcomes.
            </h2>
            <div
              className="mt-6 text-[#2A2A2B] italic leading-[1.9] text-lg prose prose-sm max-w-none"
              style={{ fontFamily: FONT.serif }}
              data-testid="bul-mission-text"
              dangerouslySetInnerHTML={{ __html: renderInstituteHtml(mission) }}
            />
          </article>
        </div>
      </PageBody>
    </div>
  );
}
